import { useState, useEffect, RefObject, useMemo, useCallback } from 'react'


export const useFullScreen = (ref: RefObject<HTMLElement>) => {
  const [isFullScreen, setIsFullScreen] = useState(false)

  useEffect(() => {

    const handler = () => {
      if (!ref.current) {
        return
      }

      setIsFullScreen(ref.current === document.fullscreenElement)
    }

    document.addEventListener('fullscreenchange', handler, false)
    return () => {
      document.removeEventListener('fullscreenchange', handler, false)
    }
  }, [ref])

  const requestFullscreen = useCallback(() => {
    if (!document.fullscreenEnabled) {
      setIsFullScreen(true)
      return
    }

    const { current } = ref
    if (!current) {
      return
    }

    current.requestFullscreen({ navigationUI: 'hide' })
  }, [ref])

  const exitFullscreen = useCallback(() => {
    if (!document.fullscreenEnabled) {
      setIsFullScreen(false)
      return
    }


    const { current } = ref
    if (!current || document.fullscreenElement !== current) {
      return
    }

    document.exitFullscreen()
  }, [ref])

  return useMemo(() => ({
    isFullScreen,
    requestFullscreen,
    exitFullscreen,
  }), [isFullScreen, requestFullscreen, exitFullscreen])

}
